// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-visibility-control__current  {
    display: inline-block;
    padding: 5px 15px;
    margin: 5px;
    border-radius: 5px;

    border: thin solid var(--primary-color-light);
    color: var(--primary-color-dark);
    background-color: var(--primary-color-light);
}
.post-visibility-control svg {
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -0.2em;
    margin-right: 5px;
}

@media (width >= 700px) {


}
@media (width < 700px) {
    .post-visibility-control__current .text {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostForm/PostVisibilityControl/PostVisibilityControl.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;;IAElB,6CAA6C;IAC7C,gCAAgC;IAChC,4CAA4C;AAChD;AACA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;AAGA;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".post-visibility-control__current  {\n    display: inline-block;\n    padding: 5px 15px;\n    margin: 5px;\n    border-radius: 5px;\n\n    border: thin solid var(--primary-color-light);\n    color: var(--primary-color-dark);\n    background-color: var(--primary-color-light);\n}\n.post-visibility-control svg {\n    width: 1.2em;\n    height: 1.2em;\n    margin-bottom: -0.2em;\n    margin-right: 5px;\n}\n\n@media (width >= 700px) {\n\n\n}\n@media (width < 700px) {\n    .post-visibility-control__current .text {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
